import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-anonymous-modal',
  templateUrl: './anonymous-modal.component.html',
  styleUrls: ['./anonymous-modal.component.scss']
})
export class AnonymousModalComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
        public dialog: MatDialog,
        public dialogRef: MatDialogRef<AnonymousModalComponent>) { }

  ngOnInit(): void {
    console.log("data", this.data);
  }

  
  closeAll(){
    this.dialogRef.close(false)
  }

  onSubmit(){
    this.dialogRef.close(true)
  }

}
